/**
 * Build query params for getBoostHistory. Drops empty values.
 */
export function buildBoostHistoryParams(filters, page, limit) {
  const params = { page, limit };
  if (filters.user_id) params.user_id = filters.user_id;
  if (filters.action) params.action = filters.action;
  if (filters.start_date) params.start_date = filters.start_date;
  if (filters.end_date) params.end_date = filters.end_date;
  if (filters.search) params.search = String(filters.search).trim();
  return params;
}
